var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitsRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0302 0.425537H10.9811V11.0153H15.0302V0.425537Z",
    fill: "#E53324"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0302 15.2147H10.9811V25.8045H15.0302V15.2147Z",
    fill: "#E53324"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.310547 11.0953V15.1444H10.9003V11.0953H0.310547Z",
    fill: "#E53324"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1006 11.0953V15.1444H25.6903V11.0953H15.1006Z",
    fill: "#E53324"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsRedIcon);
export default __webpack_public_path__ + "static/media/benefits-red-icon.1f3471976e37c2b373407c4d5659da1f.svg";
export { ForwardRef as ReactComponent };